const redirectToMercadoPago = (url: string): void => {
  window.location.href = url;
};

export default redirectToMercadoPago;
